import { DocumentNode, FetchResult } from '@apollo/client';
import { MemberUpdateInput } from '__generated__/graphql';
import { MEMBER_UPDATE_MUTATION } from 'apollo/mutations/member-mutations';
import { useApolloUpdate } from 'hooks';
import { useCallback } from 'react';
import { IMember, IMemberUpdateInput } from 'types';

interface IMutation {
  updateMember: IMember;
}

type MemberSetTuple = [
  <Key extends keyof MemberUpdateInput>(
    id: string,
    key: Key,
    value: MemberUpdateInput[Key]
  ) => Promise<FetchResult<IMutation>>, // Changed to FetchResult
  (value: IMemberUpdateInput) => Promise<FetchResult<IMutation>>, // Changed to FetchResult
];

export default function useMemberUpdate(mutation: DocumentNode = MEMBER_UPDATE_MUTATION): MemberSetTuple {
  const [updateKey, update] = useApolloUpdate<MemberUpdateInput, IMutation>(mutation, 'member');

  const updateMemberKey = useCallback(
    async <Key extends keyof MemberUpdateInput>(id: string, key: Key, value: MemberUpdateInput[Key]) => {
      return await updateKey(id, key, value);
    },
    [updateKey]
  );

  const updateMember = useCallback(
    async (value: IMemberUpdateInput) => {
      return await update(value);
    },
    [update]
  );

  return [updateMemberKey, updateMember];
}
